module.exports = __webpack_public_path__ + "img/recognition.a70d5458.png";